import dayjs from "dayjs";
import uniqid from "uniqid";
export const ASSISTANT_ID = "91";
export const BOT_NAME = "AMSBOT";
export const BOT_IMAGE =
  "https://upload.convolab.ai/convolab/images/convolab-avartar.svg";
